export default class UnavailablesModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
